import { makeStyles } from "@mui/styles"

const useStyles = makeStyles(() => ({
  date: {
    "&.MuiTypography-root": {
      fontSize: "1em",
      fontWeight: "bold",
    },
  },
}))

export default useStyles
